module.exports = __webpack_public_path__ + "static/media/Illustration-II.bd9f83a2.svg";